"use strict";

define('controller/message.template/list',['require','exports','module','../base','libs/route.helper','view/message.template/message.template.list','langs'],function (require, exports, module) {
  var RegionController = require('../base');
  var RouteHelper = require('libs/route.helper');
  var MessageTemplateListView = require('view/message.template/message.template.list');
  var langs = require('langs');
  var MessageTemplateListController = RegionController.extend({
    header: langs.phrase('App.Title'),
    authorities: ['PERM_MODIFY_MESSAGE_TEMPLATE'],
    initialize: function initialize() {
      this.root = new MessageTemplateListView();
      switch (this.state.get('tabName')) {
        case 'emails':
          this.root.openTabIndex = 0;
          break;
        case 'notifications':
          this.root.openTabIndex = 1;
          break;
      }
      this.root.$el.css(this.app.config.contentCss);
      this.messageTemplates = this.model('MessageTemplate').all();
      this.configureModelEvents();
      this.configureViewEvents();
    },
    onStart: function onStart() {
      this.state.addPageDependencies([this.messageTemplates]);
      this.messageTemplates.fetch();
      this.region.show(this.root);
    },
    configureModelEvents: function configureModelEvents() {
      this.listenTo(this.messageTemplates, 'sync', this.onMessageTemplatesSync);
    },
    configureViewEvents: function configureViewEvents() {
      this.listenTo(this.root, 'change:openTabIndex', function () {
        switch (this.root.openTabIndex) {
          case 0:
            this.state.set('tabName', 'emails');
            break;
          case 1:
            this.state.set('tabName', 'notifications');
            break;
        }
      });
    },
    createMessageTemplateDetailLink: function createMessageTemplateDetailLink(model) {
      return RouteHelper.createLink('messageTemplate:detail', model, {
        messageTemplateId: 'id'
      });
    },
    onMessageTemplatesSync: function onMessageTemplatesSync() {
      var notificationArray = [],
        emailArray = [];
      this.messageTemplates.each(function (mt) {
        switch (mt.get('templateType.name')) {
          case 'Email':
            emailArray.push(mt);
            break;
          case 'Notification':
            notificationArray.push(mt);
            break;
        }
      }, this);
      this.root.setTabData('emails', emailArray);
      this.root.setTabData('notifications', notificationArray);
    }
  });
  module.exports = MessageTemplateListController;
});

